'use strict';

import ajax from '../../ajax';
import formPrepare from './formPrepare';
import util from '../../util';
import modalExport from '../../modal';
const modal = modalExport.global;
import cardValidation from './card-validation';
import validator from '../../validator';
import progress from '../../progress';
import adyenCheckout from '../../adyen/adyen-checkout';
import checkoutAddress from './address';
import tooltip from '../../tooltip';
import inputField from '../../input-field';
import analytics from '../../analytics';
import reinsurancePanel from '../reinsurancePanel';



var $cache,recaptcha_bal_check;
var session_ShowCaptcha = SessionAttributes.SHOW_CAPTCHA;
var $otherThanCC = false;
var isOOBPaymentInstrumentsConfirmed = false;

function reinsuranceCart() {
	$(document).on('click', '.reinsurance-wrapper-cart', function (e) {
        e.stopImmediatePropagation();
        if($(this).parent().hasClass("open-reinsurance-panel")) {
            $(this).prop("disabled", false);
			var contentAssetId = $(this).parent().attr("data-content-id");
			reinsurancePanel.openReinsurancePanel(contentAssetId);
        } else {
            if($(this).hasClass('desktop-only')) {
                $(this).toggleClass('show-description')
                $(this).siblings().toggleClass('hidden');
                $(this).parents('.content-asset').toggleClass('flex-ease');
                $('.reinsurance-wrapper-cart').not(this).removeClass('show-description');
            } else {
                $(this).toggleClass('show-description')
                $(this).siblings().toggleClass('hidden');
                $(this).parents('.content-asset').toggleClass('flex-ease');
                $(this).parents('.reinsurance-checkout-mobile .content-asset').siblings().toggleClass('hide');
                $('.reinsurance-wrapper-cart').not(this).removeClass('show-description');
            } 
        }
	});
	
	$(document).ready(function() { 
        $('.reinsurance-wrapper-cart.mobile-only').parents('.content-asset').addClass('flex-ease');
        $('.reinsurance-wrapper-cart').each(function() {
            if($(this).parent().hasClass("open-reinsurance-panel")) {
                setTimeout(function(){
                    var element = $('.reinsurance-element.open-reinsurance-panel');
                    element.prop("disabled", false);
                }, 500);
            } else {
                if ($(this).find('.reinsuranceDesc').length === 0) {
                    $(this).addClass('remove-plus-icon');
                    $(this).prop("disabled", true);
                }
            }
        });
    });
    
	$(document).on('click', '.reinsurance-checkout-mobile .mobile-only', function (e) {
        e.stopImmediatePropagation();
		if(!$(this).parent().hasClass("open-reinsurance-panel")) {
			if ($(this).find('.reinsuranceDesc').length === 0){
				$(this).on('click', function(event) {
					event.preventDefault();
				});
			} else {
				$('.reinsurance-checkout-mobile .mobile-only').not(this).toggleClass('hidden');
			}
		}
	});
}


/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
	var $paymentMethods = $('.payment-method');
	var $billingForm = $('[id$="_billing"]');
	var dataMethod = paymentMethodID;
	
	// ensure checkbox of payment method is checked
	$('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
	$('input[name$="_selectedPaymentMethodID"][value=' + paymentMethodID + ']').prop('checked', 'checked');
	
	if($('.payment-method-options').length > 0) {
	
		if(paymentMethodID =="AdyenComponent") {
			// All adyen payments
			$(".other-payment-options").removeClass("alternate-selected");
			$('.other-payment-contain').removeClass('showCheckoutComponent');
			if($($billingForm).valid()) {
				$('.continue').attr("disabled", false);
			}
		} else {
			// Other payment direct PayPal
			if($($billingForm).valid()) {
				if(!Constants.IS_OOB_SESSION || (Constants.IS_OOB_SESSION && isOOBPaymentInstrumentsConfirmed)) {
					$('.continue').attr("disabled", false);
				}	
			}
			$('.checkoutComponent').hide();
			$('input[id^="is-klarna"]').removeAttr('checked');
			$('input[name="brandCode"]').removeAttr('checked');
			$('#adyenStateData').val('');
		}
	}
}

//This function will be updated later as reusable component
function updatePlaceholderCountryChange() {

	$('select[id$="_country"]').on('selectmenuchange change',function(){
		var countryValue = $('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country');
		var optionFlagValue = $('#dwfrm_billing_billingAddress_addressFields_country').find('.flag-'+countryValue.toLowerCase());
        var placeholderCity = optionFlagValue.attr('data-placeholder');
        var placeholderPhone = optionFlagValue.attr('data-phone');
        var placeholderPostal = optionFlagValue.attr('data-postal');

		//update city placeholder value with the changed country
		var nearestFieldSet = $(this).closest('fieldset');
		nearestFieldSet.find('.input-text.city').attr('placeholder', placeholderCity);
		nearestFieldSet.find('.input-text.phonenumber').attr('placeholder', placeholderPhone);
		nearestFieldSet.find('.input-text.postal').attr('placeholder', placeholderPostal);
	});
    $('select[id$="_country"]').trigger('change');

	//For BE,DE and ROE markets, the placeholder should be empty if no country is selected from dropdown
	$(document).ready(function () {
		if($('.country').hasClass('input-select')) {
			var countryVal = $('.input-select.country').val();
			var nearestFieldSet = $('.input-select.country').closest('fieldset');
			if(!countryVal) {
				nearestFieldSet.find('.input-text.city').attr('placeholder', '');
				nearestFieldSet.find('.input-text.phonenumber').attr('placeholder', '');
				nearestFieldSet.find('.input-text.postal').attr('placeholder', '');
			}
		}
	});
}

function creditCardTypeDetector(options) {

    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),

        // MasterCard
        mastercard_regex = new RegExp('^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$'),

        // American Express
        amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

        //Discover
        discover_regex = new RegExp('^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'),

        //JCB
        unionpay_regex = new RegExp('^62[0-9]{0,14}$');

    $('.cc-number input').focusout(function (e) {
        var cur_val = $(this).val();

        //Commenting this out since the event is handled on focusout
        // if ( cur_val.length == 16 ) {
        //     e.preventDefault();
        //     return;
        // }

        var $ccNumberContain = $(this).parents('.cc-number');

        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            $ccNumberContain.addClass('is_visa');
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_visa');
        }

        if (cur_val.match(mastercard_regex)) {
            $ccNumberContain.addClass('is_mastercard');
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            $ccNumberContain.addClass('is_amex');
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_amex');
        }

        if (cur_val.match(discover_regex)) {
            $ccNumberContain.addClass('is_discover');
            $creditCard.find('input[name$="_type"]').val("Discover").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_discover');
        }

        if (cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) &&
            !cur_val.match(amex_regex) && !cur_val.match(discover_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
        } else {
            $ccNumberContain.removeClass('is_nothing');
        }
    });

};

function initCache() {
    $cache = {};

    $cache.checkoutForm = $(".checkout-billing");
    $cache.selectedCardIdInput = $cache.checkoutForm.find('input[name$="_selectedCardID"]');
}

function initCreditCardForm() {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    $cache.checkoutForm.find('input[name*="_number"]').val('');

    var $ccContainer = $cache.checkoutForm.find(".payment-method").filter(function(){
        return $(this).data("method")=="CREDIT_CARD";
    });

    $ccContainer.find('input[name*="_number"]').on('change',function(e){
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });
    $ccContainer.find('input[name$="_owner"]').on('change',function(e){
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });

    $ccContainer.find('select[name*="expiration"]').on('change',function(e){
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');

        var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
        var cardNumber = $cache.checkoutForm.find('input[name*="_number"]').val();
        if(cardNumber.indexOf('****') != -1 && selectedPaymentMethodID == 'SA_SILENTPOST'){
            $cache.checkoutForm.find('input[name*="_number"]').val('');
        }
    });
}

function setSelectedCardID(uuid) {
    $cache.selectedCardIdInput.val(uuid);
}

function enableCountryField(status) {
	var countryField = $('select[id$="dwfrm_billingaddress__emea_country"]');
	if (status) {
		countryField.removeAttr('disabled');
	} else {
		countryField.prop('disabled', true);
	}
}

function addCVNEvent(){
    $('input[name$="creditCard_cvn"]').on('keydown', function(e){
        if (e.key.toString().match(/[\d]/)
                || $.inArray(e.keyCode, [8, 9, 13, 46, 33, 34, 35, 36, 37, 38, 39, 40]) >= 0) {
            // do nothing
        } else {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    });
}


function openpaybylink() {
	$('input[name="paymentmethods-option"]').on('click',function (e) {
		if($(this).val().toLowerCase() =='paybylink') {
			e.preventDefault();
			e.stopPropagation();
			modal.addCustomClass('payment-paybylink-popup');
            modal.renderContent(Resources.PAYMENT_PAYBYLINKORDER);
			$('input[name$="_selectedPaymentMethodID"]').val('paybylink');
			$(this).prop('checked', 'checked');
			addOOBPaymentInstrument('PayByLink');
		}
	});
}
function openfreeorder() {
	$('input[name="paymentmethods-option"]').on('click',function (e) {
		if($(this).val().toLowerCase() == 'freeorder'){
			e.preventDefault();
			e.stopPropagation();
            modal.addCustomClass('payment-paybylink-popup');
            modal.renderContent(Resources.PAYMENT_FREEORDER);
			$('input[name$="_selectedPaymentMethodID"]').val('freeorder');
			$(this).prop('checked', 'checked');
			addOOBPaymentInstrument('FreeOrder');
		}
	});
}
function addOOBPaymentInstrument(orderType) {
	var addOrderOnBehalfPIUrl = Urls.addOrderOnBehalfPI;
	$(document).on('click', '.confirm-paybylink-order, .confirm-free-order', function () {	
		$.ajax({
			url: addOrderOnBehalfPIUrl,
			data: {
				orderType : orderType
			},
			success: function (response) {
				if(response.success) {
					isOOBPaymentInstrumentsConfirmed = true;
					$('#billing-submit','.billing-continue-container').attr("disabled", false);
					$("#billing-submit").trigger('click');
				}
			}
		});
	});	
}

function clearConsentError() {
	var isTimer = null; 
	var $consentError = $(".checkout-step.billing .order-summary-footer .user-consent-container .error-placement");
	var $termsandconditions = $(".checkout-step.billing .order-summary-footer .user-consent-container .termsandconditions");
    $termsandconditions.removeClass("error");
	if(isTimer) {
		clearTimeout(isTimer);
	}
	isTimer = setTimeout(function(){
		if($consentError.find('span.error').is(":visible")) {
			$consentError.remove();
			$termsandconditions.prop('checked', false);
			$termsandconditions.removeClass("error");
		}
	}, 0)	
}

/**
* @function
* @description Changes the payment type or issuerId of the selected payment method
* @param {String, Boolean} value of payment type or issuerId and a test value to see which one it is, to which the payment type or issuerId should be changed to
*/
function updatePaymentType(selectedPayType, issuerType) {
	if(issuerType){
		$('#dwfrm_adyPaydata_issuer').val(selectedPayType);
	}
	else{
	  $('input[name="brandCode"]').removeAttr('checked');
	  $('input[value=' + selectedPayType + ']').prop('checked', 'checked');
	}
	
	// if the payment type has hidden fields reveal it
	$('#component_' + selectedPayType).show();
	try{
		formPrepare.validateForm();
	} catch (err) {
		console.log(err);
	}
}

function sameAsShipping() {

    $('input.sameasbilling').on('change', function () {
        savedAddressViewBilling();
        var sameascheckbox = $(this);

        if (sameascheckbox.is(":checked")) {
            $('.saved-addresses.select-billing-address').addClass('hidden');
            $('.saved-addresses.default-billing-address').removeClass('hidden');

            $('#dwfrm_billing_billingAddress_addressFields_firstName').val($('#dwfrm_billing_billingAddress_addressFields_firstName').attr('data-firstname'));
            $('#dwfrm_billing_billingAddress_addressFields_lastName').val($('#dwfrm_billing_billingAddress_addressFields_lastName').attr('data-lastname'));
            if ($('#dwfrm_billing_billingAddress_addressFields_lastName2').length > 0) {
                $('#dwfrm_billing_billingAddress_addressFields_lastName2').val($('#dwfrm_billing_billingAddress_addressFields_lastName2').attr('data-lastname2'));
            }
            $('#dwfrm_billing_billingAddress_addressFields_address1').val($('#dwfrm_billing_billingAddress_addressFields_address1').attr('data-address1'));
            $('#dwfrm_billing_billingAddress_addressFields_address2').val($('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2'));
            $('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
            $('#dwfrm_billing_billingAddress_addressFields_postal').val($('#dwfrm_billing_billingAddress_addressFields_postal').attr('data-postal'));
            $('#dwfrm_billing_billingAddress_addressFields_country').val($('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country'));
            $('#dwfrm_billing_billingAddress_addressFields_states_state').val($('#dwfrm_billing_billingAddress_addressFields_states_state').attr('data-state'));
            $('#dwfrm_billing_billingAddress_addressFields_phoneNumber').val($('#dwfrm_billing_billingAddress_addressFields_phone').attr('data-phone'));
            if ($('.checkout_page').length) {
                populatePhoneFieldsBilling($('.select-billing-address input[id$="_phone"]').val());
            } else {
                newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
            }
            $('#sameAsShippingAddress').val(true);

            // for logged-in users with address, reselect default shipping address
            // if customer chooses to use the shipping address as their billing address
            var selectedShipping = $('.select-billing-address div.address-tile.address-default');
            if (selectedShipping) {
                selectedShipping.removeClass('selected');
                selectedShipping.removeClass('default');
                selectedShipping.click();
            }

            // Check address block empty or not
            if ($(".address-name-block .address-name").length) {
                if ($(".address-name-block .address-name").html().trim().length == 0) {
                    $('.selected-billing-address').hide();
                }
            }
        } else {
            $('.saved-addresses.default-billing-address').addClass('hidden');
            $('.saved-addresses.select-billing-address').removeClass('hidden');
            $('.billing-address-section').find('.addressname').addClass('hidden');
            if ($('.checkout_page').length) {
                populatePhoneFieldsBilling($('.select-billing-address input[id$="_phone"]').val());
            } else {
                newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
            }
            $('#dwfrm_billing_billingAddress_addressFields_firstName').val('');
            $('#dwfrm_billing_billingAddress_addressFields_lastName').val('');
            if ($('#dwfrm_billing_billingAddress_addressFields_lastName2').length > 0) {
                $('#dwfrm_billing_billingAddress_addressFields_lastName2').val('');
            }
            $('#dwfrm_billing_billingAddress_addressFields_address1').val('');
            $('#dwfrm_billing_billingAddress_addressFields_address2').val('');
            $('#dwfrm_billing_billingAddress_addressFields_city').val('');
            $('#dwfrm_billing_billingAddress_addressFields_postal').val('');
            $('#dwfrm_billing_billingAddress_addressFields_phone').val('');
            $('#dwfrm_billing_billingAddress_addressFields_phoneNumber').val('');
            $('#dwfrm_billing_billingAddress_addressFields_postcode').val('');
            $('#dwfrm_billing_billingAddress_addressFields_province').val('');
            $('#dwfrm_billing_billingAddress_addressFields_states_state').val('');
            $('#dwfrm_billing_billingAddress_addressFields_states_state').selectmenu('refresh');
            $('#sameAsShippingAddress').val(false);
            $('.select-billing-address').find('.set-default-cb').addClass('hidden');

            // Remove focus on input when their are no error
            if (!$('.select-billing-address .error-placement') == false) {
                $('.select-billing-address .material-input').removeClass('focus-in');
                $('.select-billing-address .material-input .phonenumber').removeClass('error');
            }
            if ($('.checkout_page').length) {
                //keep the select country value
                $('.select-billing-address').find('.input-select.country').prop('selectedIndex',0).val();
                var countryMenu = $('#dwfrm_billing_billingAddress_addressFields_country-menu li');
                var countryVal = $('.saved-addresses.select-billing-address').closest('form').find('.input-select.country').val();

                if (countryVal == 'GB') {
                    $(countryMenu).find('.flag-gb').parent().trigger('click');
                } else if (countryVal == 'AT') {
                    $(countryMenu).find('.flag-at').parent().trigger('click');
                } else if (countryVal == 'ES') {
                    $(countryMenu).find('.flag-es').parent().trigger('click');
                } else if (countryVal == 'BE') {
                    $(countryMenu).find('.flag-be').parent().trigger('click');
                } else if (countryVal == 'IT') {
                    $(countryMenu).find('.flag-it').parent().trigger('click');
                } else if (countryVal == 'FR') {
                    $(countryMenu).find('.flag-fr').parent().trigger('click');
                } else if (countryVal == 'DE') {
                    $(countryMenu).find('.flag-de').parent().trigger('click');
                }
            }
        }
    });
}

//View More Functionality for saved billing address section of redesign
function savedAddressViewBilling() {
    var savedAddressBilling = $('.saved-addresses.select-billing-address .address-tile');
    var seeMore = $('.billing-address-show-more');
    $(document).find('.select-billing-address div.address-list div.address-tile').each(function() {
        if($('.select-billing-address div.address-default.selected').length <=0) {
            if($(this).hasClass('address-default')) {
                $(this).addClass('selected');
            }
        }
    });
    if (savedAddressBilling.length > 3) {
        if ($('.checkout-step').find('.billing-address-show-more').length == 0) {
            $('.billing-address-section').after("<div class='billing-address-show-more'>" + Resources.SEE_MORE_CARDS + "</div>");
        }

        $(seeMore).on('click', function (e) {
            if ($(seeMore).text() !== Resources.SEE_LESS_CARDS) {
                $(seeMore).text(Resources.SEE_LESS_CARDS);
                $(seeMore).addClass('is-show');
                $('.shipping-address-section .select-shipping-address').addClass('see-more-clicked');
            } else {
                $(seeMore).text(Resources.SEE_MORE_CARDS);
                $(seeMore).removeClass('is-show');
                $('.shipping-address-section .select-shipping-address').addClass('see-more-clicked');
            }

            savedAddressBilling.toggle();
        });
    }

    if ($('input.sameasbilling').is(":checked")) {
        $('.billing-address-show-more').hide();
    } else if ((!$('input.sameasbilling').is(':checked')) && savedAddressBilling.length > 3) {
        $('.billing-address-show-more').show();
    }
}

function sameAsShippingUpdate() {
    var sameasBilling = $('input.sameasbilling');
    //update the checkobox with backend value
    if (($(sameasBilling).length > 0 && $('#sameAsShippingAddress').val() == null) || ($(".checkout_page").length && !$(sameasBilling).is(":checked"))) {
        $(sameasBilling).trigger('change');
    }
    // if same as shipping is checked, re-select default address
    // or if nothing is selected, re-select default address
    if (($(sameasBilling).length > 0 && $(sameasBilling).is(":checked") && $('#sameAsShippingAddress').val() == null) ||
        $('.select-billing-address div.address-list div.address-tile.selected').length <= 0) {

        $(document).find('.select-billing-address div.address-list div.address-tile').each(function (ind, evt) {
            if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
                $(this).removeClass('selected');
                $(this).removeClass('default');

                $(this).trigger('click');
            }

            if($('.select-billing-address div.address-tile.selected').length <=0) {
                if($(this).hasClass('address-default')) {
                    $(this).addClass('selected');
                }
            }
        });
    } else if ($(sameasBilling).length == 0 && $('div.address-list div.address-tile.selected').length > 0) {
        // if no physical product to ship, re-select tile to properly assign billing address
        var reSelectTile = $('.select-billing-address div.address-list div.address-tile.selected');
        reSelectTile.removeClass('selected');
        reSelectTile.removeClass('default');
        reSelectTile.trigger('click');
    }
}

function populatePhoneFieldsBilling(phone) {
    /*
        This code is replica of address-form.js populatePhoneFields function, Due function don't have 
        dynamic selector this is only effect first selector caught in DOM, And we have a two form in the 
        shipping page where phone filed populated with first shipping form instead of billing form. This
        code need to optimize with dynamic selector in the address-form.js and will be removed from here later on.
    */
    var selectedCountryCode = $('.select-billing-address select[id$="_country"]').data('country');
    if (selectedCountryCode) {
        var areaCode = util.getCallingCountryCode(selectedCountryCode.toLowerCase());
        if (areaCode && phone) {
            var phonenumber = phone.replace(new RegExp("^(\\" + areaCode + ")[\\s-]*(\\d{6,18})$"), "$2");
            $('.select-billing-address input[id$="_areaCode"]').val(areaCode);
            $('.select-billing-address input[id$="_phoneNumber"]').val(phonenumber);
        }
        $('.select-billing-address select[id$="_country"]').val(selectedCountryCode).trigger('change');
    }
}

function toggleCountryFields() {
    $(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country, #dwfrm_billingaddress__emea_country', function () {
        // populating country code for phone number in billing page
        var selectContry = $(this).val(),
            callingCountryCode = util.getCallingCountryCode(selectContry),
            phoneFiled = $(this).closest('form').find('input[name$="_phone"]');

        phoneFiled.val(callingCountryCode);
        phoneFiled.attr('data-country-code', callingCountryCode);
        util.handleCountryCodeUpdate(phoneFiled);

        if (selectContry == '') {
            toggleBillingAddressFields();
        } else if (selectContry == 'us' || selectContry == 'ca') {
            toggleBillingAddressFields(true);
            $('.us-fields').show();
            $('.us-fields input').each(function () {
                $(this).addClass('required');
            });

            $('.cn-fields').hide();
            $('.cn-fields input').each(function () {
                $(this).removeClass('required');
            });
        } else {
            toggleBillingAddressFields(true);
            $('.us-fields').show();
            $('.us-fields input').each(function () {
                $(this).addClass('required');
            });

            $('.cn-fields').hide();
            $('.cn-fields input').each(function () {
                $(this).removeClass('required');
            });

        }
    });
}

function billingAddressFunctions () {
	$('.saved-addresses.select-billing-address').on('click', '.address-list .address-tile', function (evt) {
		if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
			return false;
		} else {
			$('.saved-addresses.select-billing-address').find('.address-list .address-tile').each(function () {
				$(this).removeClass('selected');
				$(this).removeClass('default');
			});

			$(this).addClass('selected');

			var element = document.getElementById(evt.currentTarget.id);
			var addressID = element.dataset.addressId;

			var sameasBilling = $('body').hasClass('checkout_page') ? 'input.sameasbilling' : 'input#same-as-shipping';
			var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
				addressID: addressID, isSameAsShipping : $(sameasBilling).is(':checked'),
			});
			$.ajax({
				url: url,
				type: 'GET',
				success: function (result) {getValidPostalCity(addressID,false,true);	}
			});
			clearConsentError();
		}
	});
}

    /*
     * Valid Postal and City
     */
    function getValidPostalCity(addressId,displModal,disableBut,addressCode){
    	var $form = $('form[id$="_billing"]');
    	var $submit = $form.find('button[type="submit"]');
    	
    	if(!Constants.IS_OOB_SESSION || (Constants.IS_OOB_SESSION && isOOBPaymentInstrumentsConfirmed)) {
            disableBut == true ? $submit.removeAttr('disabled') : '';
        }
        if(displModal){
            initEditAddressModal(addressId, false, addressCode);
        }
    	
    }
    
    function toggleBillingAddressFields(visible) {
        if (visible == true) {
            $('.country-dependent').each(function() {
                $(this).show();
            });
        } else {
            $('.country-dependent').each(function() {
                $(this).hide();
            });
        }
        
        if (window.User.isCustomerAuthenticated == false) {
        	$('.checkout-billing').find('.set-default-cb').hide();
        }
    }

    // display accordion on mobile devices for product information
    function initMobileProductInformation() {
        $(document).on('click', '.checkout-articles', function(e) {
            e.stopImmediatePropagation();
            $(".checkout-articles .down-arrow, .checkout-articles .up-arrow").toggleClass("hide");
            $(".checkout-mini-cart").toggleClass("hide");
        });
    }

    // custom scroll for product information
    function initScrollProductInformation() {
        $(".mini-cart-product-container").scrollBox();
    }

    $(window).on('load', function() {
        var isTablet = window.matchMedia("(max-width: 768px)").matches;
        if (!isTablet) {
            initScrollProductInformation();
        }
    });

    function handleCreditCardFields() {
        $('.other-payment-options').on('click',function (){
            $('#newCard').prev('.credit-card-icons-container').addClass('hide-new-card');
        });
        $('.credit-card-icons-container').on('click',function(){
            $('#newCard').prev('.credit-card-icons-container').removeClass('hide-new-card');
            $('.other-payment-contain .additionalFields').hide();  
        });
    }


function checkoutReinsurancePopup() {
	$(document).on('click', 'a.cart-reinsuance-modal', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $this = $(this);
        analytics.reinsuranceElements($this.attr('id'));		
        
        $.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
            method: 'GET'
        })
        .done(function (response) { 
            if(response) {
                modal.addCustomClass('checkout-reinsurance-inner-wrapper');
                modal.renderContent(response);
            }
        });
	});
}

/**
 * @function
 * @description loads billing address, Coupon and Payment methods
 */
export default {
    init : function () {
    setTimeout(function() {
        reinsuranceCart();
    }, 1000);
    cardValidation.init();
    checkoutReinsurancePopup();
    initCache();
    initCreditCardForm();
    initMobileProductInformation();
    util.characterLimitEvents();
    if(Constants.IS_OOB_SESSION) {
		openfreeorder();
		openpaybylink();
		$('#billing-submit').attr("disabled", true);
		$('#billing-submit').on('click', function () {
			if(!isOOBPaymentInstrumentsConfirmed) {
				event.preventDefault();
				return false;
			}
		});
		
		$(document).on('click', '.close-button, .modal-close, .modal-close-outer, .modal-close-btn', function () {
			if(!isOOBPaymentInstrumentsConfirmed) {
				$('#billing-submit','.billing-continue-container').attr("disabled", true);
			}	
		});
	}
    var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find('input[name$="_selectedPaymentMethodID"]:checked').val();
    var $payType = $('[name="brandCode"]');
    var $issuer = $('.issuer');
    if($payType !== 'undefined' && $payType.length > 0) {
    	var selectedPayType = $payType.find(':checked').val();
    }
    validator.initForm('form[id$="billing"]');
    
    var $form = $('form[id$="billing"]');            	

    function toggleBillingAddressFields(visible) {
        if (visible == true) {
            $('.country-dependent').each(function() {
                $(this).show();
            });
        } else {
            $('.country-dependent').each(function() {
                $(this).hide();
            });
        }
        
        if (window.User.isCustomerAuthenticated == false) {
        	$('.checkout-billing').find('.set-default-cb').hide();
        }
    }

    if($('.checkout-billing .other-payment-contain').children().length > 1){
    	$('.other-payment-contain').addClass('multiple-payment-options');
    	$('.other-payment-contain').find('label[for="is-PayPal"]').find('.logo').addClass('paypal-float-left');
    	$('.other-payment-contain').find('.paypal-float-left').closest('.form-row.label-inline').addClass('form-row-paypal');
    }

    $('.billing-address-section :input').on('change', function(e) {
        if (e.target.id == 'dwfrm_billing_billingAddress_useAsBillingAddress') {
            return false;
        }

        $('#dwfrm_billing_billingAddress_useAsBillingAddress').prop('checked', false);
    });
    if($(".applepay-container-wrapper").length) {
        $('.applepay-container-wrapper, .applepay-container-wrapper button').hide();
    }
    $('.address1').attr('autocomplete', 'on'); // Avoid to autocomplete address 1
    // default payment method to 'CREDIT_CARD'
    updatePaymentMethod((selectedPaymentMethod) ? selectedPaymentMethod : 'CREDIT_CARD');
    
    $selectPaymentMethod.on('click', 'input[name$="_selectedPaymentMethodID"]', function () {
    	updatePaymentMethod($(this).val());
    	if ($(this).val() == 'Adyen' && $payType.length > 0) {
            // set payment type of Adyen to the first one
            updatePaymentType((selectedPayType) ? selectedPayType : $payType[0].value, false);
         } else {
            $payType.removeAttr('checked');
         }
    });

    if($payType !== 'undefined' && $payType.length > 0) {
	    $payType.on('click', function () {
	    	updatePaymentType($(this).val(), false);
	        $('input[value="Adyen"]').prop('checked', 'checked').trigger('click');
	        
	        if(Constants.KLARNA_GRP_METHOD.indexOf($(this).val()) > -1) {
	            $('.single-klarna-option').parents('.component-container').addClass('klarna-comp-wrapper');
	            
				$('.klarna-component').on('change', function () {
	                $('input[id^="is-klarna"]').val($(this).val());
				});
			}
	    });
    }    
    	
    $issuer.on('change', function () {
    	updatePaymentType($(this).val(), true);
    });
    	
    creditCardTypeDetector();

    $(document).on("click", ".credit-card-create", function (evt) {
        modal.events.onOpen(function () {
            creditCardTypeDetector();
            validator.initForm('form[id$="CreditCardForm"]');
        });
        modal.restoreDefaultClass();
        modal.addCustomClass('medium add-credit-card');
        modal.renderByUrl(Urls.checkoutAddCreditCard);
        modal.setCallback(cardValidation.init);
    });

    $(document).on("submit", "#CreditCardForm", function (evt) {
            evt.preventDefault();

            var $form = $(this);

            $.ajax({
                url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
                data: $form.serialize() + '&' + $form.find('#applyBtn').attr('name') + '=x',
                type: 'POST'
            }).done(function (data) {
                if (data.length) {
                    modal.setContent(data);
                	validator.initForm('form[id$="CreditCardForm"]');
                    return;
                }

                if (!location.assign(Urls.billing)) {
                    window.location.href = Urls.billing;
                }
            });
        });

    $(document).on("click", ".credit-card-edit", function (evt) {
        var element = document.getElementById(evt.currentTarget.id);
        var creditcardPositin = element.dataset.creditcardPosition;
        var url = Urls.checkoutEditCreditCard + creditcardPositin;

        modal.restoreDefaultClass();
        modal.events.onOpen(function () {
            $('.cc-number input').prop('disabled', true);
            validator.initForm('form[id$="CreditCardForm"]');
        });
        modal.addCustomClass('small edit-credit-card');
        modal.renderByUrl(url);

    });


        /**
    * @function
    * @description Updates billing form address fields based on same as shipping checkbox is checked or not
    * @param {Object} sameascheckbox
    */

        sameAsShipping();

        $(document).on('ready', function() {		
            sameAsShippingUpdate();
            billingAddressFunctions ();
        });
    
        toggleCountryFields();

    //select credit card tile
    $(document).on('click', '.creditcard-tile', function (evt) {
        var $this = $(this);

        var ccEdit = $this.find('.credit-card-edit');
        var fauxCVNInput = '<div class="cvn-input"></div>';
        var CVNInput = '<input class="input-text " type="text" id="dwfrm_billing_paymentMethods_creditCard_cvn" name="dwfrm_billing_paymentMethods_creditCard_cvn" value="" maxlength="4" aria-invalid="false">';

        if (evt.target == ccEdit[0]) {
            return;
        }

        if ($(this).is('.selected, .default')) {
            return false;
        } else {
            $('.creditcard-tile').each(function () {
                $(this).removeClass('selected');
                $(this).removeClass('default');
                $(this).find('.saved-cvn').addClass('disabled');
                $(this).find('.saved-cvn input').replaceWith(fauxCVNInput);
            });

            $this.addClass('selected');
            $this.find('.cvn-input').removeClass('disabled');
            $this.find('.saved-cvn .cvn-input').replaceWith(CVNInput);
            $this.find('.saved-cvn input').focus();

            var element = document.getElementById(evt.currentTarget.id);

            var creditcardPosition = element.dataset.creditcardPosition;

            var url = util.appendParamsToUrl(Urls.checkoutCreditCardSelection, {
                position: creditcardPosition,
            });
            $.ajax({
                url: url,
                type: 'GET',
                success: function (result) {
                }
            });

            setSelectedCardID($this.data("uuid"));
            addCVNEvent();
        }

    });

    $(document).on("click", ".billing-address-section .address-create", function (evt) {
         modal.setCallback(function() {
             toggleBillingAddressFields(false);
         });

    	 modal.restoreDefaultClass();
    	 modal.addCustomClass('edit-add-address new-add-address billing');
    	 modal.events.onOpen(function() {
    		 validator.initForm('form[id$="EditAddressForm"]');
             validator.changeFieldValidation();
    		 checkoutAddress.init();
             tooltip.init();
             $('html').addClass('modal-open');
    	 });

    	 modal.renderByUrl(Urls.checkoutAddBillingAddress);
         setTimeout(() => {
            $('.address1').attr('autocomplete', 'on'); // Avoid to autocomplete address 1
            util.limitCharacters();
            if($('#EditAddressForm').find('.lastname2').length >= 1) {
                $('fieldset.form-details').scrollBox();
            }
            if($('.input-text.valid').length<=7 || $('.input-text.error').length>=0) {
                $('button[type="submit"').prop('disabled',true);
            }
        }, 2500);
        modal.events.onClose(function() {
            $('html').removeClass('modal-open');
        });
    });

    $(".billing-address-section .address-edit.text-only").on('click',function (evt) {
        validator.changeFieldValidation();
        var element = document.getElementById(evt.currentTarget.id);
        var addressID = element.dataset.addressId;
        var addressCode = element.dataset.addressCode;
        
        getValidPostalCity(addressID,true,false,addressCode);
        setTimeout(() => {
            $('.address1').attr('autocomplete', 'on'); // Avoid to autocomplete address 1
            util.limitCharacters();
            updatePlaceholderCountryChange();
            if($('#EditAddressForm').find('.lastname2').length >= 1) {
            $('fieldset.form-details').scrollBox();
            }
        }, 2500);
    });

    $(document).on('click', '.address-list .address-tile', function (evt) {

        if ( $(this).is('.selected, .default') || evt.target.nodeName == 'A') {
            return false;
        } else {
        $('.address-list .address-tile').each(function() {
            $(this).removeClass('selected');
            $(this).removeClass('default');
        });

        $(this).addClass('selected');

        var element = document.getElementById(evt.currentTarget.id);
        var addressID = element.dataset.addressId;
        var addressCode = element.dataset.addressCode;        
        

        var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
            addressID: addressID, isSameAsShipping : $('#same-as-shipping').is(':checked'),
            //format: 'ajax'
        });
        $.ajax({
            url: url,
            type: 'GET',
            success: function (result) {
            	getValidPostalCity(addressID,false,true,addressCode);   
            }
        });
        clearConsentError();
        }

    });

    $('.order-summary-footer form').submit(function() {
        $('#summary-place-order').prop('disabled', true).addClass('loading');
        return true;
    });

    // if same as shipping is checked, re-select default address
    // or if nothing is selected, re-select default address
    if (($('input#same-as-shipping').length > 0 && $('input#same-as-shipping').is(":checked"))
    		|| $('div.address-list div.address-tile.selected').length <= 0) {
        $(document).find('div.address-list div.address-tile').each(function(ind, evt) {
            if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
                $(this).removeClass('selected');
                $(this).removeClass('default');

                $(this).click();
            }
        });
    } else if ($('input#same-as-shipping').length == 0 && $('div.address-list div.address-tile.selected').length > 0) {
        // if no physical product to ship, re-select tile to properly assign billing address
        var reSelectTile = $('div.address-list div.address-tile.selected');
        reSelectTile.removeClass('selected');
        reSelectTile.removeClass('default');
        reSelectTile.click();
    }

    // trigger click event for selected by default cc (to manually trigger cc code)
    var selectedCC = $('div.payment-method div.creditcard-tile.selected');
    if (selectedCC) {
        selectedCC.removeClass('selected').click();
    }

    // maximize order checkout summary dropdown
    util.maximizeCheckoutSummary();

    // trigger only for non-registered users
    if (window.User.isCustomerAuthenticated == false) {
        $('input[name$="_creditCard_cvn"], input[name$="_creditCard_owner"]').on('change', function() {
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
        });
    }
    
    $(document).ready(function() {
    	if($("form").hasClass("checkout-billing")){
    		$(document).keypress(function(e) {
    		    var code = (e.keyCode ? e.keyCode : e.which);
    		    if ( (code==13) || (code==10)){//android and ios GO button
    		    	e.preventDefault();
    				e.stopPropagation();
    		    	$('#billing-submit').click();
    		        }
    		});
    	}
    })
    
    if (SitePreferences.ADYEN_SF_ENABLED && $('#dwfrm_billing').length > 0) {
    	adyenCheckout.initBilling();
	}
    if($payType !== 'undefined' && $payType.length > 0) {
    	$payType.on('change', function() {
        	var $checkoutComponent = $('.checkoutComponent');
        	$('#selectedIssuer').val("");
        	$issuer.hide();
        	$checkoutComponent.hide();
        	$('#component_' + $(this).val()).show();
        	
        	if ($(this).siblings( ".issuer").length > 0) {
        		$('#selectedIssuer').val($(this).siblings( ".issuer" ).val());
        		$(this).siblings('.issuer').show();
        	}
        	if(Constants.KLARNA_GRP_METHOD.indexOf($(this).val()) > -1) {
    			$('.klarna-component-wrapper').show();
    		}
    		else {
    			$('.klarna-component-wrapper').hide();
    		}
        	var $otherPaymentCont = $('.other-payment-contain');
        	if($checkoutComponent.is(':visible')) {
        		$otherPaymentCont.addClass('showCheckoutComponent');
        		progress.hide('#main');
        	} else {
        		$otherPaymentCont.removeClass('showCheckoutComponent');
        	}
    	});
    }
    
    $(window).on('load', function() {		 
        if($('#apple-pay-wrapper').find('button.dw-apple-pay-button').length !== 0){
            $('#apple-pay-wrapper').css('display','block');
        }
        // to enable autocomplete for city and postal fields (FR locale)
        checkoutAddress.init();
        clearConsentError();
	 });
    
    /*
     * Valid Postal and City
     */
    function getValidPostalCity(addressId,displModal,disableBut,addressCode){
    	var $form = $('form[id$="_billing"]');
    	var $submit = $form.find('button[type="submit"]');
    	
    if(!Constants.IS_OOB_SESSION || (Constants.IS_OOB_SESSION && isOOBPaymentInstrumentsConfirmed)) {
        disableBut == true ? $submit.removeAttr('disabled') : '';
    }
    if(displModal){
        initEditAddressModal(addressId, false, addressCode);
    }
    	
    	
    }


    function initEditAddressModal(addressID, invalidateFields, addressCode){
    	 var url = Urls.checkoutEditBillingAddress + addressID;

         modal.setCallback(function() {
             if (addressCode == 'us' || addressCode == 'ca') {
                 toggleBillingAddressFields(true);
                 $(".us-fields").show();
                 $(".cn-fields").hide();
                 enableCountryField(false);
             } else if (addressCode == 'cn') {
                 toggleBillingAddressFields(true);
                 $(".cn-fields").show().css({"display" : "flex"});
                 $(".us-fields").hide();
                 enableCountryField(false);
             } else {
                 toggleBillingAddressFields(true);
                 enableCountryField(true);
                 $('select[id$="_country"]').val($('[name$="CountryCodeFromSavedAddress"]').val());
             }
             
            // initialize address.js to validate city and postal feilds
            checkoutAddress.init();
            // if city and postal not valid
            if(invalidateFields) {
                $('#EditAddressForm .postal').val('');
                $('#EditAddressForm .city').val('');
                validator.initEmptyInputValidation($('#EditAddressForm .postal'));
                validator.initEmptyInputValidation($('#EditAddressForm .city'));
            }
            tooltip.init();
         });
         modal.restoreDefaultClass();
         modal.addCustomClass('edit-billing-address');
         modal.events.onOpen(function() {
         	validator.initForm('form#EditAddressForm');
         	var $form = $('form[id$="EditAddressForm"]');
         	var savedCountry = $form.find('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country');
             var countryCode = util.getCallingCountryCode(savedCountry);
             var phoneFiled =  $form.find('input[name$="_phone"]');
             phoneFiled.attr('data-country-code', countryCode);
             util.handleCountryCodeUpdate(phoneFiled);
             inputField.setEditMaterialFields();
             tooltip.init();
             $('html').addClass('modal-open');
         });
         modal.renderByUrl(url);   
         inputField.setEditMaterialFields();
         modal.events.onClose(function() {
            $('html').removeClass('modal-open');
        });	
    }
    util.getPhoneNumWithCode();
    $('.alert.error-form').length > 0 && $('.checkout-header-container').addClass('payment-err');
    savedAddressViewBilling();
    $('.input-select.country').prop('selectedIndex',0).val();

	handleCreditCardFields();

    var $termsandconditions = $(".checkout-step.billing .order-summary-footer .user-consent-container .termsandconditions");
    $termsandconditions.removeClass("error");
    }
}

export const singleShippingDesign = function () {
    checkoutAddress.init();
    sameAsShipping();
    sameAsShippingUpdate();
    billingAddressFunctions ();
    util.getPhoneNumWithCode();
}